export var ColorOption;
(function (ColorOption) {
    ColorOption["none"] = "none";
    ColorOption["all"] = "all";
})(ColorOption || (ColorOption = {}));
